import {
	faAddressCard,
	faAngleRight,
	faBook,
	faBug,
	faChartBar,
	faChartLine,
	faCogs,
	faDatabase,
	faFileAlt,
	faFileCircleExclamation,
	faHeadset,
	faList,
	faListCheck,
	faSearchPlus,
	faSignOutAlt,
	faUser,
} from '@fortawesome/free-solid-svg-icons';
import { menuItemInterface } from 'src/app/util/interfaces/menuItem';

export const MenuItems: menuItemInterface[] = [
	{
		isAnalystView: false,
		routerLink: '/request',
		name: 'lbl_geral_chamado',
		icon: faHeadset,
		permissions: ['access_request'],
		children: [],
	},
	{
		isAnalystView: false,
		routerLink: '/cockpit',
		name: 'Cockpit',
		icon: faChartBar,
		permissions: ['access_cockpit'],
		children: [],
	},
	{
		isAnalystView: false,
		routerLink: '/report',
		name: 'lbl_geral_reports',
		icon: faFileAlt,
		permissions: ['access_reports'],
		children: [],
	},
	{
		isAnalystView: true,
		routerLink: '/register',
		name: 'lbl_geral_cadastro',
		icon: faAddressCard,
		permissions: ['access_register'],
		children: [],
	},
	{
		isAnalystView: true,
		routerLink: '/',
		name: 'CMDB',
		icon: faDatabase,
		permissions: ['access_cmdb'],
		expanded: false,
		children: [
			{
				isAnalystView: true,
				routerLink: '/cmdb/list',
				name: 'lbl_listagem_ativos',
				icon: faList,
				permissions: ['access_cmdb'],
				children: [],
			},
			{
				isAnalystView: true,
				routerLink: '/cmdb/dashboard',
				name: 'Dashboard',
				icon: faChartLine,
				permissions: ['access_cmdb'],
				children: [],
			},
			{
				isAnalystView: true,
				routerLink: '/cmdb/equipment-history',
				name: 'lbl_historico_equipamentos_usuario',
				icon: faFileAlt,
				permissions: ['access_reports'],
				children: [],
			},
		],
	},
	{
		isAnalystView: true,
		routerLink: '/knowledgebase',
		name: 'Knowledge',
		icon: faBook,
		permissions: ['access_kb'],
		children: [],
	},
	{
		isAnalystView: true,
		routerLink: '/checklist',
		name: 'Checklist',
		icon: faListCheck,
		permissions: ['access_checklist'],
		children: [],
	},
	{
		isAnalystView: false,
		routerLink: '',
		name: 'MyAsset',
		icon: faSearchPlus,
		permissions: ['access_myasset'],
		expanded: false,
		children: [
			{
				isAnalystView: false,
				routerLink: '/myasset/dashboard',
				name: 'Dashboard',
				icon: faChartLine,
				permissions: ['access_myasset'],
				children: [],
			},
			{
				isAnalystView: false,
				routerLink: '/myasset/inconsistency',
				name: 'lbl_geral_inconsistencias',
				icon: faBug,
				permissions: ['access_myasset'],
				children: [],
			},
			{
				isAnalystView: false,
				routerLink: '/myasset/exception',
				name: 'lbl_excecao_inconsistencia',
				icon: faFileCircleExclamation,
				permissions: ['access_myasset'],
				children: [],
			},
			{
				isAnalystView: false,
				routerLink: '/myasset/configuration',
				name: 'lbl_configuracao_myasset',
				icon: faCogs,
				permissions: ['configuration_myasset'],
				children: [],
			},
		],
	},
	{
		isAnalystView: false,
		routerLink: '/users',
		name: 'Usuários',
		icon: faUser,
		permissions: ['access_users'],
		children: [],
	},
	{
		isAnalystView: false,
		routerLink: '',
		name: 'lbl_geral_desconectar',
		icon: faSignOutAlt,
		permissions: [],
		children: [],
		onClick: () => {
			// Add your disconnect logic here
		},
	},
];
